import { ParameterListDTO } from '../parameter/parameter-list.dto';

export class DashboardParametersDTO {

    system: Array<ParameterListDTO>;

    user: Array<ParameterListDTO>;

}
